export default {
  'ikg.export': 'Export',
  'ikg.import': 'Import',
  'ikg.add': 'Add',
  'ikg.edit': 'Edit',
  'ikg.delete': 'Delete',
  'ikg.save': 'Save',
  'ikg.cancel': 'Cancel',
  'ikg.confirm': 'Confirm',
  'ikg.sure': 'Sure',
  'ikg.search': 'Search',
  'ikg.reset': 'Reset',
  'ikg.query': 'Query',
  'ikg.operation': 'Operation',
  'ikg.input': 'Please enter {{name}}',
  'ikg.select': 'Please select {{name}}',
  'ikg.addSibling': 'Add sibling directory',
  'ikg.addChildren': 'Add child directory',
  'ikg.pass': 'Pass',
  'ikg.error': 'Error',
  'ikg.loginAgain':
    'Account has been inactive for a long time, please log in again',
  'ikg.noAuth': 'No permission',
  'ikg.to': 'To',
  'ikg.userManage': 'User Management',
  'ikg.roleManage': 'Role Management',
  'ikg.create': 'Create',
  'ikg.success': '{{action}} successful',
  'ikg.deleteConfirm': 'Are you sure you want to delete?',
  'ikg.unDeleteConfirm': 'Are you sure you want to undo the deletion?',
  'ikg.passConfirm': 'Are you sure you want to pass?',
  'ikg.warn': 'Prompt',
  'ikg.logoutConfirm': 'Are you sure you want to log out?',
  'ikg.logout': 'Log out',
  'ikg.changePwd': 'Change password',
  'ikg.index': 'Index',
  'ikg.rename': 'Rename',
  'ikg.version': 'Version',
  'ikg.total': '{{count}} in total',
  'ikg.toTop': 'Back to top',
  'ikg.selectCount': '{{count}} items selected',
  'ikg.move': 'Move',
  'ikg.moveToDir': 'Move to target directory',
  'ikg.movePlaceholder': 'Please select or enter the directory name',
  'ikg.merge': 'Merge',
  'ikg.mergeToDir': 'Merge to target directory',
  'ikg.mergePlaceholder': 'Please select or enter the directory name',
  'ikg.moveTip': 'Moving will move the currently selected directory to the target directory and become its subdirectory. All subsets under the current directory will also move with it.',
  'ikg.mergeTip': 'Merging will move all subdirectories under the currently selected directory to the target directory and delete the current directory.',

  // dict
  'dict.viewTitle': 'Dictionary View',
  'dict.editTitle': 'Dictionary Edit',
  'dict.auditTitle': 'Dictionary Audit',
  'dict.knowledgeView': 'Knowledge View',
  // 'dict.knowledgeMaintain': 'Knowledge Maintain',
  'dict.knowledgeAudit': 'Knowledge Maintain',
  'dict.addDirSingle': 'Add Dictionary',
  'dict.code': 'Code',
  'dict.name': 'Name',
  'dict.type': 'Category',
  'dict.source': 'Source',
  'dict.updateTime': 'Update Date',
  'dict.dictType': 'Dictionary Domain',
  'dict.publishTime': 'Publish Date',
  'dict.exportBy': 'Exported By',
  'dict.exportTime': 'Export Time',
  'dict.searchTree': 'Please enter code/name',
  'dict.cancelDel': 'Undo Delete',
  'dict.addWord': 'Add Entry',
  'dict.exportPkg': 'Export Dictionary Package',
  'dict.pkgName': 'Export Dictionary Package Name',
  'dict.pkgNameExtra':
    'Naming convention: Project name_Dictionary domain_Dictionary name_Dictionary version number_Export date',
  'dict.project': 'Use Project',
  'dict.desc': 'Description',
  'dict.submitVersion': 'Submit Version',
  'dict.addVersion': 'Add Version',
  'dict.publishVersion': 'Publish Version',
  'dict.submitVersionTxt':
    'After submission, you cannot submit again. Are you sure you want to submit this version of the dictionary?',
  'dict.filterSwitch': 'Show only items to be passed',
  'dict.createMethod': 'Creation Method',
  'dict.inherit': 'Inherit Existing Version',
  'dict.createNew': 'Create New',
  'dict.dictName': 'Dictionary Name',
  'dict.inheritVersion': 'Inherit Version',
  'dict.versionNo': 'Create Version Number',
  'dict.addDir': 'Create Dictionary Domain',
  'dict.publishText':
    'There are still items to be reviewed in the current version. Do you want to pass all the revised entries and publish the version?',
  'dict.publishText2': 'Are you sure you want to publish the version',
  'dict.quote': 'Quote',
  'dict.dictVersion': 'Dictionary Version',
  'dict.auditPass': 'Audit Pass',
  'dict.exportMethod': 'Export Method',
  'dict.onlyItemExport': 'Only Entry Export',
  'dict.dirAndItemExport': 'Directory and Entry Export',
  'dict.batchAuditMax': 'Audit up to 100 items at a time',
  'dict.version': '版本号',
  // meddra导入
  'dict.mdhierAsc': 'mdhier.asc',
  'dict.lltAsc': 'llt.asc',
  // whodrugc3导入
  'dict.mpcsv': 'MP.csv',
  'dict.suncsv': 'SUN.csv',
  'dict.thgcsv': 'ThG.csv',
  'dict.ccodecsv': 'CCODE.csv',
  'dict.pfcsv': 'PF.csv',
  'dict.atccsv': 'ATC.csv',
  // whodrugb3
  'dict.ddcsv': 'DD.csv',
  'dict.bnacsv': 'BNA.csv',
  'dict.inacsv': 'INA.csv',
  'dict.ddacsv': 'DDA.csv',
  'dict.INGcsv': 'ING.csv',
  // omop导入
  'dict.conceptcsv': 'CONCEPT.csv',
  'dict.conceClasscsv': 'CONCEPT_CLASS.csv',
  'dict.domaincsv': 'DOMAIN.csv',
  'dict.conceRelcsv': 'CONCEPT_RELATIONSHIP.csv',
  'dict.relcsv': 'RELATIONSHIP.csv',
  'dict.selectFile': 'Select File',
  'dict.drugName': 'Drug Name',
  'dict.drugNameType': 'Name Type',
  // Export record
  'export.title': 'Export Record',
  'export.searchProject': 'Please enter project number or name',
  'export.projectName': 'Project Name',
  'export.projectDeleted': 'This project has been deleted',
  // user
  'user.oldPwd': 'Old Password',
  'user.newPwd': 'New Password',
  'user.confirmPwd': 'Confirm Password',
  'user.pwdNotSame': 'The two passwords are not the same',
  'user.pwdRequired': 'Password cannot be empty',
  'user.pwdRegex':
    'The password must contain uppercase letters, lowercase letters, numbers, and special characters, and be 8-16 characters long',

  // knowledge
  'knowledge.txt1': 'Adverse Event',
  'knowledge.txt2': 'Definition',
  'knowledge.txt3': 'Extended Notes',
  'knowledge.txt4': 'Grade 1',
  'knowledge.txt5': 'Grade 2',
  'knowledge.txt6': 'Grade 3',
  'knowledge.txt7': 'Grade 4',
  'knowledge.txt8': 'Grade 5',
  'knowledge.txt9': 'System Organ Classification',
  'knowledge.txt10': 'Generic Name',
  'knowledge.txt11': 'Brand Name',
  'knowledge.txt12': 'English Name',
  'knowledge.txt13': 'Active Ingredient',
  'knowledge.txt14': 'Manufacturer',
  'knowledge.txt15': 'Specification',
  'knowledge.txt16': 'Dosage Form',
  'knowledge.txt17': 'National Approval Number',
  'knowledge.txt18': 'Drug Standard Code',
  'knowledge.txt19': 'Attachment',
  'knowledge.txt20': 'Name',
  'knowledge.instruction': 'Instructions',
  'knowledge.drugName': 'Drug Name',
  'knowledge.ingredients': 'Ingredients',
  'knowledge.indications': 'Indications',
  'knowledge.usage': 'Dosage and Administration',
  'knowledge.adverseReactions': 'Adverse Reactions',
  'knowledge.taboo': 'Contraindications',
  'knowledge.formatFileError': 'Import File Format Error',
  'knowledge.mattersNeedAttention': 'Precautions',
  'knowledge.txt21': 'Geriatric Use',
  'knowledge.txt22': 'Drug Interactions',
  'knowledge.txt23': 'Overdose',
  'knowledge.txt24': 'Pharmacology and Toxicology',
  'knowledge.txt25': 'Pharmacokinetics',
  'knowledge.txt26': 'Storage',
  'knowledge.txt27': 'Packaging',
  'knowledge.txt28': 'Shelf Life',
  'knowledge.txt29': 'Standards',
  'knowledge.txt30': 'Manufacturer',

  'dict.lowLevelLang': 'Low-Level Language',
  'dict.lltCurrency': 'Current Use',
  'dict.drugRecordNo': 'Drug Code',
  'dict.substanceName': 'Active Ingredient',
  'dict.country': 'Country',
  'dict.dosageForm': 'Dosage Form',
  'dict.conceptCode': 'Concept Code',
  'dict.classType': 'Category',
  'dict.conceptType': 'Concept Type',
  'dict.conceptDomain': 'Concept Domain',
  'dict.quoteItem': 'Quote Selected Entry',
  'dict.quoteDir': 'Quote Current Directory',
  'dict.quoteDict': 'Quote Dictionary',
  'dict.itemId': 'Entry ID',
  'dict.preferredName': '【Preferred Name】',
  'ikg.back': 'Back',
  'dict.createKnowledgeDomain':'create knowledge domain',
  'dict.createKnowledgeBase':'create knowledge base',
  'knowledge.regName':'The name can only contain Chinese characters, English letters, numbers and underscores',
  'ikg.createDoc':'create a document',
  'ikg.confirmUpload':'confirm upload',
  'ikg.confirmContent':'Continuing to upload will overwrite the documents with the same name',
  'ikg.fileLimit':'The file size cannot exceed 30 megabytes',
  'ikg.uploadSuccess':'upload success',
  'ikg.keywordRetrieval':'keyword retrieval',
  'ikg.updateTime':'update time',
  'ikg.confirmDeleteContent':'are you sure',
  'ikg.unSupport':'Currently, browsing of this document is not supported. Please download it for viewing',
  'ikg.downloadFile':'Download the document',
  'dict.editKnowledgeBase':'edit knowledge base'






}
